import * as React from 'react';


export class YesNoRadioButtons extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            yes: String(this.props.value)
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({
            yes: event.target.value
        });
        if (this.props.onClick !== undefined)
            this.props.onClick(event.target.value);
    }


    render() {
        return (
            <fieldset style={{ "border": "none" }}>
                <legend class="visuallyhidden">{this.props.legend}</legend>
                <div className='radioButton'>
                    <input id={this.props.id + 'Yes'} name={this.props.id} type="radio" value="true" checked={this.state.yes ? this.state.yes === 'true' : undefined} onChange={this.handleChange} disabled={!this.props.canEdit} />
                    <label for={this.props.id + 'Yes'}>Yes</label>
                    <input id={this.props.id + 'No'} name={this.props.id} type="radio" value="false" checked={this.state.yes ? this.state.yes === 'false' : undefined} onChange={this.handleChange} disabled={!this.props.canEdit} />
                    <label for={this.props.id + 'No'}>No</label>
                </div>
            </fieldset>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/YesNoRadioButtons.js